var map = {
	"./__tests__/en.test": 161,
	"./__tests__/en.test.json": 161,
	"./en": 162,
	"./en-base": 163,
	"./en-base.json": 163,
	"./en.json": 162,
	"./id": 164,
	"./id.json": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1943;